import { GlobalLoader } from '@juvare/common-web-ui/GlobalLoader';
import { PageError } from '@juvare/common-web-ui/PageError';
import React from 'react';
import { useAppConfig } from '../hooks/useAppConfig';

export const ConfigLoader: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
    const { error, isLoading } = useAppConfig();

    if (error) {
        return <PageError error={error} />;
    }

    if (isLoading) {
        return <GlobalLoader />;
    }

    return <>{children}</>;
};
